export default __webpack_public_path__ + "static/media/star.37971bc4.svg";